<!--<app-splash></app-splash>-->

<div class="card m-1">
  <p-breadcrumb [model]="breadItems"></p-breadcrumb>
</div>

  <div class="card m-1" *ngIf="startRendering && !lineNotBelongsTaAccount">
      <app-cc-line-summary *ngIf="fullLineInfo!=null&&!isPair" [isPair]="isPair" [lineSummary]="fullLineInfo" [style]="{'width':'100%'}"></app-cc-line-summary>
      <app-cc-line-summary *ngIf="parentFullLineInfo!=null&&isPair" [isPair]="isPair" [lineSummary]="parentFullLineInfo" [pairNum]="fullLineInfo?.pairNum" [style]="{'width':'100%'}"></app-cc-line-summary>


    <!--depend on pair , show which component -->
    <!--<app-hatteras-container *ngIf="fullLineInfo?.pairNum > 0" [fullLineInfo]="fullLineInfo"></app-hatteras-container>-->
    <!--*ngIf="fullLineInfo?.pairNum==null || fullLineInfo?.pairNum==0"-->
    <app-normal-container *ngIf="!isPair" [isPair]="isPair" [fullLineInfo]="fullLineInfo"></app-normal-container>
    <app-normal-container *ngIf="isPair" [isPair]="isPair" [fullLineInfo]="fullLineInfo" [parentFullLineInfo]="parentFullLineInfo"></app-normal-container>
  </div>
<div *ngIf="lineNotBelongsTaAccount" [style]="{'width':'100%'}">
  <div class="col-md-12 col-sm-12 m-1" [style]="{'width':'100%'}">
    <!--<strong> This Line Not Belong to this Account</strong>-->
    <img src="../../../../assets/error404.jpg" />
  </div>
</div>

